import { Model } from 'miragejs';

import type { User } from '@app/interfaces/User';

export const UserModel = Model.extend<Partial<User>>({});
